import Player from "@vimeo/player";
import 'jquery-zoom';
import aos from 'aos/dist/aos';

export default {

    init() {
        // JavaScript to be fired on all pages

        window.visual_slide_carousel_config = {
            autoplay: true,
            dots: true,
            arrows: false,
            adaptiveHeight: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        adaptiveHeight: false,
                    },
                },
                {
                    breakpoint: 992,
                    settings: {
                        adaptiveHeight: true,
                    },
                },
            ],
        };


    },

    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        aos.init({
            startEvent: 'load',
            once: true,
            duration: 800,
            offset: 50,
        });

        var scrollpos;
        $('#hamburger').on('click', function () {
            // console.log('hamburger click');
            if ($('body').attr('class') === undefined || $('body').attr('class').indexOf('hamburger-is-active') === -1) {
                // console.log('open layer');
                scrollpos = $(window).scrollTop();
                $('body').addClass('hamburger-is-active');
                setTimeout(function () {
                    $('body').addClass('body-blocked');
                }, 300);
            } else {
                // console.log('close layer');
                $('body').removeClass('body-blocked');
                $("body").removeClass('hamburger-is-active');
                $('.nav-item').removeClass('show');
                $('html, body').scrollTop(scrollpos);
            }
        });

        //collapsed header on mobile
        if ($(window).width() < 992) {
            $('header').addClass('collapsed');
            $('#main-content').addClass('collapsed');
        }

        // MENU
        $(window).on('scroll', function () {
            if ($(window).width() >= 992) {
                var scroll = $(window).scrollTop();
                if (scroll > 300) {
                    $('header').addClass('collapsed');
                    $('#main-content').addClass('collapsed');
                } else {
                    if (scroll < 200) {
                        $('header').removeClass('collapsed');
                    }
                    if (scroll < 100) {
                        $('#main-content').removeClass('collapsed');
                    }
                }
            }
        });

        $(".nav-item.menu-item.active").addClass("current");
        // Add hover effect to menus

        $(".nav-item.menu-item")
            .on('mouseenter', function () {
                if ($(window).width() >= 992) {
                    $(".nav-item.menu-item").removeClass("active");
                    $(this).addClass("active");
                }
                if ($(this).hasClass("submenu")) {
                    $(this).find(".layer-submenu").addClass("show");
                }
            })
            .on("mouseleave", function () {
                if ($(window).width() >= 992) {
                    $(".nav-item.menu-item").removeClass("active");
                    $(".nav-item.menu-item.current").addClass("active");
                }
                if ($(this).hasClass("submenu")) {
                    $(this).find(".layer-submenu").removeClass("show");
                }
            });

        $(".layer-submenu li")
            .on('hover', function () {
                if ($(window).width() >= 992) {
                    $(".nav-item.menu-item").removeClass("active");
                    $(this).parent().parent().addClass("active");
                }
            });
        $(".nav-item.menu-item.submenu").on("click", function () {
            if ($(window).width() < 992) {
                $(".nav-item.menu-item.submenu").removeClass("show");
                $(this).addClass("show");
            }
        });

        // crea custom select option from category - subcategory
        /*var foundin = $('#lista_categorie option:contains("optgroup-")');
        console.log('route page');
        if (foundin.length > 0) {
            $.each(foundin, function (value) {
                var updated = $(this).val().replace('optgroup-', '');
                $(this).nextUntil('option:contains("endoptgroup")').wrapAll('<optgroup label="' + updated + '"></optgroup>');
            });
            $('#lista_categorie option:contains("optgroup-")').remove();
            $('#lista_categorie option:contains("endoptgroup")').remove();
        }*/

        if ($(".slider_carousel").length > 0) {
            $(".slider_carousel").each(function (i, elem) {
                $(elem).slick(window.visual_slide_carousel_config)
                    .on('afterChange', function () {
                        // console.log("afterChange");
                        adjust_slide_height(elem);
                    })
                    .on('init', function () {
                        // console.log("init");
                        adjust_slide_height(elem);
                    })
                    .slick('slickGoTo', 0);
            });
        }

        function adjust_slide_height(elem) {
            if ($(window).width() >= 992) {
                $(elem).find(".slider_carousel-box").each(function (j, elem2) {
                    $(elem2).css({
                        "height": $(elem2).find(".slider_carousel-bg-image").height(),
                    });
                });
            }
        }

        $(window).on('load', function () {
            if ($(".slider_carousel").length > 0) {
                $(".slider_carousel").each(function (i, elem) {
                    // console.log("resize");
                    adjust_slide_height(elem);
                })
            }
        });

        $(window).on('resize', function () {
            if ($(".slider_carousel").length > 0) {
                $(".slider_carousel").each(function (i, elem) {
                    // console.log("resize");
                    adjust_slide_height(elem);
                })
            }
        }).resize();


        $('.play-video').on('click', function () {
            $("#modal-show-video").modal('show');
        });

        var iframe_video_visual = document.getElementById('video-visual');
        if (iframe_video_visual !== null) {
            if (iframe_video_visual.nodeName === 'IFRAME' && iframe_video_visual.getAttribute('src') !== null && iframe_video_visual.getAttribute('src') !== '' && iframe_video_visual.getAttribute('src') !== undefined) {
                var player_video = new Player(iframe_video_visual);
                var $modal = $("#modal-show-video");

                player_video.pause();

                $modal.on('shown.bs.modal', function () {
                    if ($(window).width() > 768) {
                        player_video.play();
                    }
                });

                $modal.on('hide.bs.modal', function () {
                    player_video.pause();
                });
            }
        }

        //todo zoom prodotto
        jQuery(document).ready(function () {
            var $list_prodotto = $(".single-prodotto");
            // console.log($list_prodotto);
            if ($list_prodotto.length > 0) {
                $list_prodotto.each(function () {
                    var imgUrl = $(this).attr('data-img-full');
                    if ($(window).width() > 768) {
                        $(this).find(".img-zoom").zoom({ url: imgUrl });
                    }
                    $(this).on("click", function () {
                        var $modal = $('#productModal');
                        $modal.find('img').attr('src', imgUrl);
                        $modal.modal('show');
                    });
                });
            }
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js